export default __webpack_public_path__ + "static/logo-4d1f34b40a81e77947d735daf6159b37.png";